import { render, staticRenderFns } from "./PowerBiFrame.vue?vue&type=template&id=1b4bb548&"
import script from "./PowerBiFrame.vue?vue&type=script&lang=ts&"
export * from "./PowerBiFrame.vue?vue&type=script&lang=ts&"
import style0 from "../assets/css/components/power-bi.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports